import Box from '@mui/material/Box';
import {
  ArrayInput, AutocompleteInput, BooleanInput, SimpleFormIterator, TextInput, required,
} from 'react-admin';

import { awardShowChoices, grammyCategoryChoices } from '@/Helper/DropdownChoices/dropdownChoices';

function EngineerAwardsInput() {
  return (
    <ArrayInput source='DiscographyAlbumEngAwards' label='Awards'>
      <SimpleFormIterator
        inline disableReordering
        disableClear
      >
        <Box
          mb={2} p={2}
          border={1} borderRadius={2}
          borderColor='grey.200' width='100%'
        >
          <AutocompleteInput
            source='Category'
            label='Category'
            choices={grammyCategoryChoices}
            fullWidth
            validate={required()}
          />
          <TextInput
            source='Year' label='Year'
            fullWidth sx={{ mt: 2 }}
            validate={required()}
          />
          <AutocompleteInput
            source='Name'
            label='Award Show'
            choices={awardShowChoices}
            fullWidth
            sx={{ mt: 2 }}
            validate={required()}
          />
          <BooleanInput
            source='Won' label='Won?'
            sx={{ mt: 2 }}
          />
        </Box>
      </SimpleFormIterator>
    </ArrayInput>
  );
}

export default EngineerAwardsInput;
